<template>
  <v-dialog
    v-model="showDocumentDialog"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <document-info
      :infoSidebar="infoSidebar"
      @closeInfoSidebar="infoSidebar = false"
      :doc="doc"
    />

    <document-discussion
      :discussionSidebar="discussionSidebar"
      @closeDiscussionSidebar="discussionSidebar = false"
      :doc="doc"
    />

    <v-layout column>
      <v-toolbar fixed>
        <v-layout align-center>
          <v-layout>
            <v-btn icon @click="close">
              <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
            </v-btn>
            <v-layout column class="mx-4">
              <span class="body-1 grey--text text--darken-2">DocGo</span>
              <v-tooltip
                class="subheading font-weight-bold text-truncate pr-5"
                max-width="500"
                z-index="999"
                nudge-left
              >
                <span slot="activator">{{ doc.document_type.name }}</span>
                <span>{{ doc.document_type.name }}</span>
              </v-tooltip>
            </v-layout>
          </v-layout>
          <v-layout justify-end>
            <v-tooltip bottom :z-index="300">
              <v-btn slot="activator" @click="download(doc)" :loading="mountingDownload" flat icon>
                <v-icon size="18" color="grey darken-2">mdi-file-download</v-icon>
              </v-btn>
              <span>Download do Documento com a Folha de Assinatura</span>
            </v-tooltip>

            <v-btn
              v-if="doc.mime_type === 'application/pdf'"
              icon
              @click="discussionSidebar = true"
            >
              <v-badge right overlap color="blue darken-1">
                <span slot="badge">{{ doc.comments.length }}</span>
                <v-icon size="18" color="grey darken-2">mdi-comment-multiple</v-icon>
              </v-badge>
            </v-btn>
            <v-btn icon @click="infoSidebar = true">
              <v-icon size="18" color="grey darken-2">mdi-information</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-text>
        <v-container v-show="showPdfViewer && doc.mime_type === 'application/pdf'" class="mt-5">
          <PdfViewer
            v-bind="{url}"
            @document-rendered="onDocumentRendered"
            @document-errored="showPDFError"
          />
        </v-container>
        <v-container
          v-if="doc.mime_type !== 'application/pdf'"
          class="mt-5 custom-container"
          fill-height
          :url="src"
        >
          <v-layout justify-center align-center>
            <video id="video" v-if="showVideo" controls :src="last(doc.document_versions).file"/>
            <audio id="sound" v-if="showPlayer" controls :src="last(doc.document_versions).file"/>
            <img v-if="showImage" :src="last(doc.document_versions).file"/>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <loader-dialog :showLoader="loading" message="Carregando documento..."/>
  </v-dialog>
</template>

<script>
import {isEmpty, last} from 'lodash';
// import pdf from 'vue-pdf';
import DocumentDiscussion from '@/components/document/show/DocumentDiscussion';
import DocumentInfo from '@/components/document/show/DocumentInfo';
import LoaderDialog from '@/components/LoaderDialog';
import bus from '@/utils/event-bus';
import PdfViewer from '@/components/pdf/PdfViewer';
import DocumentService from '@/services/DocumentsService';

export default {
  name: 'DocumentDialog',
  components: {
    DocumentDiscussion,
    DocumentInfo,
    LoaderDialog,
    // pdf,
    PdfViewer,
  },
  data() {
    return {
      isEmpty,
      infoSidebar: false,
      discussionSidebar: false,
      last,
      loading: true,
      pages: 0,
      showImage: false,
      showVideo: false,
      showPdfViewer: false,
      showPlayer: false,
      url: '',
      mountingDownload: false,
    };
  },
  props: {
    doc: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
    showDocumentDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    download(doc) {
      this.mountingDownload = true;
      const popup = window.open('', '_blank');
      DocumentService
        .download(doc.id)
        .then((response) => {
          popup.location.href = response.data.url;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.mountingDownload = false;
        });
    },
    close() {
      this.$emit('closeDocumentDialog');
    },
    showPDFError() {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: 'Não foi possível carregar o PDF. Tente atualizar a página e caso o erro persista, entrar em contato com o suporte!',
        messageIcon: 'mdi-alert-outline',
      });
    },
    loadPdf() {
      const documentSelected = last(this.doc.document_versions);
      bus.$emit('load-pdf', documentSelected.file);
      this.showPdfViewer = true;
    },
    loadAudio() {
      this.loading = false;
      this.showPlayer = true;
    },
    loadImage() {
      this.loading = false;
      this.showImage = true;
    },
    loadVideo() {
      this.loading = false;
      this.showVideo = true;
    },
    onDocumentRendered() {
      this.loading = false;
    },
  },
  watch: {
    showDocumentDialog(newValue) {
      this.internalShowDialog = newValue;
    },
    internalShowDialog(newValue) {
      // Emit an event when the internal state changes
      // The parent component can listen to this event using `@update:showDocumentDialog`
      this.$emit('update:showDocumentDialog', newValue);
    },
  },
  mounted() {
    if (this.doc.mime_type === 'application/pdf') {
      this.loadPdf();
    } else if (this.doc.mime_type === 'audio/mpeg' || this.doc.mime_type === 'application/mp3') {
      this.loadAudio();
    } else if (
      this.doc.mime_type === 'image/png' ||
      this.doc.mime_type === 'image/jpg' ||
      this.doc.mime_type === 'image/jpeg'
    ) {
      this.loadImage();
    } else if (
      this.doc.mime_type === 'video/mp4'
    ) {
      this.loadVideo();
    }
  },
};
</script>

<style>
.v-badge__badge {
  height: 15px;
  width: 15px;
  font-size: 10px;
}

.custom-container {
  height: calc(100vh - 64px);
}
</style>



// WEBPACK FOOTER //
// src/components/document/show/DocumentDialog.vue